import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Pincode - Get All (Read)
export const GetAllPincode = createAsyncThunk(
  "masters/pincode/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Pincode}?name=${filter?.name ||
          ""}&city_id=${filter?.city_id || ""}&state_id=${filter?.state_id ||
          ""}&country_id=${filter?.country_id || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Pincode - Get (Read)
export const GetPincode = createAsyncThunk(
  "masters/pincode/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Pincode}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Pincode - Create (Add)
export const AddPincode = createAsyncThunk(
  "masters/pincode/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.Pincode, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Pincode - Update
export const UpdatePincode = createAsyncThunk(
  "masters/pincode/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.Pincode}/${id}`, {
        name: data.name,
        country_id: data.country_id,
        state_id: data.state_id,
        city_id: data.city_id,
        incentive: data.incentive,
      });
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Pincode - Delete
export const DeletePincode = createAsyncThunk(
  "masters/pincode/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.Pincode}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Pincode - Status
export const StatusPincode = createAsyncThunk(
  "masters/pincode/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Pincode}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "pincode",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetPincode.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdatePincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdatePincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (city) => city.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdatePincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeletePincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeletePincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter((city) => city.id !== action.payload);
      })
      .addCase(DeletePincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StatusPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusPincode.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(StatusPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
